import { render, staticRenderFns } from "./CallerVerifyFooter.vue?vue&type=template&id=238cec7c&scoped=true"
import script from "./CallerVerifyFooter.vue?vue&type=script&lang=js"
export * from "./CallerVerifyFooter.vue?vue&type=script&lang=js"
import style0 from "./CallerVerifyFooter.vue?vue&type=style&index=0&id=238cec7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238cec7c",
  null
  
)

export default component.exports